import React from 'react';

const Description = (props) => {
    const { description, setDescription, isDisabled, isEmptyDescriptionAllowed, creatingNewAssignment } = props;
    return (
        <div className='form-group'>
            <label>Beskrivning:</label>
            <input
                disabled={isDisabled}
                type='text'
                className='form-control'
                value={description}
                onChange={(event) => setDescription(event.target.value)}
            />
            {!isDisabled && !isEmptyDescriptionAllowed && description === '' && (
                <div className={`invalid-feedback${creatingNewAssignment ? ' text-muted' : ''}`}>Beskrivningen får inte vara tom.</div>
            )}
        </div>
    );
};

export default Description;
